module.exports = {
    RandomSearchRepeatLimit: 5,
};